export default {
  set_full_name(state, user_full_name) {
    if (user_full_name) {
      state.user_full_name = user_full_name;
      localStorage.setItem("user_full_name", state.user_full_name);
      return user_full_name;
    }
    localStorage.removeItem("user_full_name");
    return;
  },
  set_language(state, user_language) {
    if (user_language) {
      state.user_language = user_language;
      localStorage.setItem("user_language", state.user_language);
      return user_language;
    }
    localStorage.removeItem("user_language");
    return;
  },
  set_entity_types(state, entity_types) {
    if (entity_types) {
      state.user_entity_types = entity_types;
      localStorage.setItem("user_entity_types", JSON.stringify(entity_types));
      return entity_types;
    }
    localStorage.removeItem("user_entity_types");
    return null;
  },
};
